import EditableDatePicker from 'components/forms/editableDatePicker';
import events from 'lib/events';
import moment from 'moment';
import React from 'react';
import ReportDropDown from '../../components/reportDropDown';
import {dateTimeFormats, salesProductCategoryFormat, reportDateFormat} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class MissedProductSalesOptions extends React.Component {
  state = {};

  componentWillMount() {
    this.resetFilters();
  }

  resetFilters = () => {
    let filters = this.props.defaultFilters;

    this.setState({
      branch: filters.branch,
      categoryType: filters.categoryType,
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
    });
  };

  updateData = () => {
    this.props.updateReportData(
      moment(this.state.dateFrom).format(dateTimeFormats.numeralDate),
      moment(this.state.dateTo).format(dateTimeFormats.numeralDate),
      this.state.branch,
      this.state.categoryType,
    );
  };

  updateDates = data => {
    if (data.key === 'dateFrom') {
      if (this.validateDates(data.value, this.state.dateTo)) {
        this.setState({
          dateFrom: data.value,
        });
      }
    } else if (data.key === 'dateTo') {
      if (this.validateDates(this.state.dateFrom, data.value)) {
        this.setState({
          dateTo: data.value,
        });
      }
    }
  };

  validateDates = (dateFrom, dateTo) => {
    if (moment(dateFrom).isAfter(dateTo)) {
      let {formatMessage} = this.props.intl;

      events.publish('error.user', {
        message: formatMessage({id: 'general.error.invalid.dates'}),
        key: 'invalidDates',
      });
      return false;
    }
    return true;
  };

  render() {
    let stores = [];
    let systemTypes = [];
    let categoryTypes = [];
    let {formatMessage} = this.props.intl;
    let salesProductCategory = salesProductCategoryFormat(formatMessage);

    if (this.props.branches !== null && this.props.branches !== undefined && this.props.branches.length > 0) {
      var obj = this.props.branches;

      stores = Object.keys(obj).map(function(key) {
        return {value: obj[key].id, label: obj[key].name};
      });
      stores.unshift({
        value: this.props.defaultFilters.branch, label: formatMessage({id: 'general.all.stores'}),
      });
    }

    categoryTypes = Object.keys(salesProductCategory).map(function(key) {
      return {value: key, label: salesProductCategory[key]};
    });
    categoryTypes.unshift({value: this.props.defaultFilters.categoryType, label: formatMessage({id: 'general.all'})});

    return <div className="report-options">
      <div className="top-title-bar">
        <FormattedMessage id="general.report.options"/>
      </div>
      <div className="select-options container-fluid">
        <div className="row">
          <div className="col-sm-3">
            <div className='form-group'>
              <label><FormattedMessage id="general.date.from"/></label>
              <EditableDatePicker
                onChange={this.updateDates}
                dataKey='dateFrom'
                value={this.state.dateFrom}
                maxDate={moment(this.state.dateTo).clone().subtract(1, 'days')}
                editMode={true}
                dateFormat={reportDateFormat}/>
            </div>
          </div>
          <div className="col-sm-3">
            <div className='form-group'>
              <label><FormattedMessage id="general.date.to"/></label>
              <EditableDatePicker
                onChange={this.updateDates}
                dataKey='dateTo'
                value={this.state.dateTo}
                minDate={moment(this.state.dateFrom).clone()}
                maxDate={moment()}
                editMode={true}
                dateFormat={reportDateFormat}/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <ReportDropDown value={this.state.branch}
                            label={formatMessage({id: 'general.store'})}
                            onChange={e => this.setState({branch: e.target.value})}
                            options={stores}/>
          </div>
          <div className="col-sm-3">
            <ReportDropDown value={this.state.categoryType}
                            label={formatMessage({id: 'general.product.category'})}
                            onChange={e => this.setState({categoryType: e.target.value})}
                            options={categoryTypes}/>
          </div>
        </div>
      </div>
      <div className="manage-options">
        <div className="col-sm-12 button-group">
          <a className="reset-button pull-right"
             onClick={this.resetFilters}><FormattedMessage id="general.reset"/></a>
          <a className="btn btn-primary pull-right"
             onClick={this.updateData}><FormattedMessage id="reports.update.summary"/></a>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(MissedProductSalesOptions);
